import {Model} from "@vuex-orm/core";

export default class BeneficiaryAssignment extends Model {
    static entity = 'Household\\Model\\BeneficiaryAssignment';

    static fields() {
        return {
            id: this.attr(null),
            household_id: this.number(null),
            primary: this.boolean(true),
            percentage: this.number(''),
            assigned_id: this.number(''),
            assigned_type: this.attr(''),
            assignable_id: this.number(''),
            assignable_type: this.attr(''),
            assigned: this.morphTo('assigned_id', 'assigned_type'),
            assignable: this.morphTo('assignable_id', 'assignable_type'),
        }
    }
}
